<template>
  <div>
<v-layout fill-height>
   <v-flex sm6 class="overflow-auto"><v-container>
    <v-text-field v-model="leftBaseUrl"></v-text-field>
    <v-text-field v-model="leftUrl">
      <!-- Tic Downlowad Left -->
      <template #append>
        <v-icon v-if="leftReady">mdi-check</v-icon>
      </template>
    </v-text-field> 
    <template>
      <v-row>
        <v-culomn>
        <v-select
        margin-left="1000 px"
        v-model="Layer.name"
        hide-details
        :items="Layers.Order"
        label="Layer">
        >
        </v-select>
       </v-culomn>
       <v-culomn>  
        <v-text-field label="Number" v-model="Layer.number" @change="UpdateRightURLNumber" id="leftUrlNumber" ></v-text-field>  
       </v-culomn>
       <v-culomn>  
        <v-btn icon @click="downloadLeft"><v-icon>mdi-download</v-icon></v-btn>
        <v-btn icon :disabled="!leftReady || !rightReady" @click="compare"><v-icon>mdi-compare</v-icon></v-btn>
      </v-culomn>
      </v-row>
    </template>  
    <v-text-field label="Def" v-model="compareRoot.defId"></v-text-field>
    <v-text-field label="Attr" v-model="compareRoot.attrName"></v-text-field>
    <v-treeview
      dense
      :items="leftItems"
      activatable
      transition
      return-object
      open-all
      >
      <template #label="{item}">
        <span :class="{
          'green--text': item.diffs.find(d => d.right == null),
          'red--text': item.diffs.find(d => d.left == null),
          'blue--text': item.diffs.find(d => d.left != null && d.right != null),
          'purple--text': !item.diffs.length && item.childrenDiffs,
          'grey--text': !item.diffs.length && !item.childrenDiffs && item.parentDiff,
          'cyan--text': !item.diffs.length && !item.childrenDiffs && !item.parentDiff
          }">{{item.name}} {{item.diffs.length ? item.diffs.length : ''}}</span>
      </template>
    </v-treeview>
  </v-container></v-flex>
  <v-flex sm6 class="overflow-auto"><v-container>
    <v-text-field v-model="rightUrl">
      <template #append>
        <v-icon v-if="rightReady">mdi-check</v-icon>
      </template>
      <template #append-outer>
        <v-btn icon @click="downloadRight"><v-icon>mdi-download</v-icon></v-btn>
      </template>
    </v-text-field>
    <template>
      <v-row>
       <v-culomn>  
        <v-text-field label="Number" value="leftUrlNumber" v-model="rightUrlNumber" id="rightUrlNumber"></v-text-field>  
       </v-culomn>
      </v-row>
      <v-text-field label="Def" v-model="compareRoot2.defId"></v-text-field>
    </template>  
    <pre>{{selectedItem && selectedItem.length === 1 && selectedItem[0].diffs.map(d => ({type: d.type, left: d.left != null, right: d.right != null}))}}
{{selectedItem && selectedItem.length === 1 && selectedItem[0].diffs}}
    
{{selectedItem && selectedItem.length === 1 && selectedItem[0].attr}}      
    </pre>
  </v-container></v-flex>
  <v-bottom-sheet v-model="showError" overlay-color="red" hide-overlay>
    <v-alert type="error">
      <pre>{{error}}</pre>
    </v-alert>
  </v-bottom-sheet>
  <v-dialog
      v-model="dialog1.show"
  >
    <v-card>
      <v-card-title>
        ...
      </v-card-title>
      <v-card-text v-if="dialog1.checkboxes">
        {{dialog1.checkboxes.selected}}
        <v-row>
          <v-col 
              cols="3" 
              v-for="item in dialog1.checkboxes"
              :key="item.value"
          >
            <v-checkbox
                :label="item.text"
                v-model="dialog1.checkboxes.selected"
                :value="item.value"
                :disabled="item.disabled"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            @click="dialog1.show = false; dialog1.callback(true)"
        >
          OK
        </v-btn>

        <v-btn
            color="green darken-1"
            text
            @click="dialog1.show = false; dialog1.callback(false)"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-layout>
    <v-switch label="Group by version" v-model="groupBy" value="leftVer"></v-switch>
    <v-row><v-col v-for="type in new Set(diffs.map(i => i.type))" :key="type"><v-checkbox :value="type" v-model="types" :label="type"></v-checkbox></v-col></v-row>
    <v-data-table :items="diffs.map((item, ix) => ({
            ...item,
            leftJson: item.left && JSON.stringify(item.left),
            rightJson: item.right && JSON.stringify(item.right),
            leftVer: item.left && item.left.ver || item.leftDef && item.leftDef.ver || 'N/A', 
            id: ix, 
            path: left.id.split('.').filter(s => s).concat(item.path.split('.').slice(1).filter(s => !s.startsWith('@'))).map(s => s.split(':')[0]).join('.'), 
            isSelectable: item.type === 'Array.Left.Def' || item.type === 'Attr.Diff.Value' || item.type === 'Attr.Left' || item.type === 'Def.Exclude.Left' || item.type === 'Attr.Value.Exclude.Left' || item.type === 'Def.Revert.Left' || item.type === 'Attr.Value.Revert.Left'
        }))" 
            :headers="['type', 'leftVer', 'path', 'attr', 'leftJson', 'rightJson'].map(n=>({text: n, value: n, width: (n.endsWith('Json') ? '500px' : undefined)}))" :items-per-page="-1" :sort-by="['leftVer', 'path']" :group-by.sync="groupBy" show-select @input="updateScript" v-model="selectedRows"
            :search="JSON.stringify(types)"
            :custom-filter="function (value, search, item) { return types.includes(item.type) }"
            >
      <template #item.attr="{item, value}">
        {{value && value.name}}
        {{diffs[item.id].path.split('.').slice(-1).filter(s => s.startsWith('@')).map(s => s.replace(/^@/, '').replace(/\[\]$/, '')).pop()}}
      </template>
      <template #item.leftJson="{value}">
        <v-expansion-panels accordion flat tile v-if="value && value.length > 500">
        <v-expansion-panel style="max-width: 500px">
          <v-expansion-panel-header><div style="max-width:400px" class="text-truncate">{{value}}</div></v-expansion-panel-header>
          <v-expansion-panel-content><div class="text-wrap" style="word-break: break-word;">{{value}}</div></v-expansion-panel-content>
        </v-expansion-panel>
        </v-expansion-panels>
        <div v-else class="text-wrap" style="word-break: break-word;">{{value}}</div>
      </template>
      <template #item.rightJson="{value}">
        <v-expansion-panels accordion flat tile v-if="value && value.length > 500">
          <v-expansion-panel style="max-width: 500px">
            <v-expansion-panel-header><div style="max-width:400px" class="text-truncate">{{value}}</div></v-expansion-panel-header>
            <v-expansion-panel-content><div class="text-wrap" style="word-break: break-word;">{{value}}</div></v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div v-else class="text-wrap" style="word-break: break-word;">{{value}}</div>
      </template>
      <template #item.path="{value}">
        <div class="text-wrap" style="word-break: break-word">{{value}}</div>
      </template>
    </v-data-table>
    <v-textarea v-model="script"></v-textarea>
    <div><v-btn @click="downloadLeftVers" :disabled="!diffReady" :loading="downloading">Download Vers</v-btn></div>
    <v-data-table :items="vers.flatMap(j => flatten(j).map(i => ({...i, ver: j.ver})))" :headers="['ver', 'op', 'path', 'value'].map(n=>({text: n, value: n}))" :items-per-page="-1" group-by="ver">
      <template #item.value="{value}">
        {{value && JSON.stringify(value)}}
      </template>
    </v-data-table>
  </div>
  
</template>

<script>

  export default {
    name: 'DefAdmin',
    async mounted() {

    },

    created() {

    },

    data: () => ({
      Layers: {
    Order: [
      { text: "Base", value: null },
      { text: "Policy", value: "#PolicyID" },
      { text: "Party", value: "#PartyID" },
      { text: "Contract", value: "#ContractID" },
      { text: "Variant", value: "#VariantID" },
      { text: "User", value: "#UserID" },
      { text: "Unit", value: "#UnitID" },
    ],
  },
      Layer:{
        name:null,
        number:null
      },
      rightUrlNumber:null,
      leftBaseUrl: "/proxy/https:day-develop.karestanjavan.ir/v1/def",
      leftUrl: "/Root/Root/$seed",
      leftUrl2: "/Root/Root/$seed/$get",
      rightUrl: "/proxy/https:abruat.karestanjavan.ir/v1/def/Root/Root/$seed",
      rightUrl2: "/proxy/https:abruat.karestanjavan.ir/v1/def/Root/Root/$seed/$get",
      groupBy: [],
      types: ['Array.Left.Def', 'Attr.Diff.Value', 'Attr.Left', 'Def.Exclude.Left', 'Attr.Value.Exclude.Left', 'Def.Revert.Left', 'Attr.Value.Revert.Left', 'Attr.Right', 'Def.Exclude.Right'],
      leftRoot: null,
      rightRoot: null,
      leftReady: false,
      rightReady: false,
      compareRoot: {
          defId: "LA",
        attrName: ""
      },
      compareRoot2: {
          defId: "LA",
        attrName: ""
      },
      diffReady: false,
      downloading: false,
      diffs: [],
      vers: [],
      leftItems: [],
      selectedRows: [],
      script: "",
      selectedItem: null,
      id: {last: 0},
      active: [],
      open: [],
      attributes: [],
      items: [],
      changes: "",
      showError: false,
      _error: "",
      set error(value) {
        console.log("set error", this.showError, value)
        this.showError = true
        this._error = value;
        setTimeout(() => {
          this.showError = false;
          this._error = ""
        }, 5000)
      },
      get error() {
        return this._error;
      },
      saving: false,
      search: null,
      treeLoaded: false,
      paths: [],
      changed: false,
      reloading: false,
      dialog1: {
        show: false,

      },
    }),

    methods: {
        UpdateRightURLNumber(){ 
        var x = document.getElementById("leftUrlNumber").value;
        this.rightUrlNumber=x
      },
      async downloadLeft() {
        this.leftReady = false
        this.leftRoot = null
        var result
        if(this.Layer.name===null)
        {
         result = await fetch(this.leftBaseUrl + this.leftUrl)
        }
        else{
        const body=JSON.stringify({"layer":{"name": "", "kind": "", "attrs": [{"name": this.Layer.name, "value":{"number": this.Layer.number}}]}})
        result = await fetch(this.leftBaseUrl + this.leftUrl2,
        {method: 'POST', headers: {'Accept': 'application/json','Content-Type': 'application/json'},body:body })
        }

        if (result.ok) {  
          this.leftRoot = await result.json()
          this.leftReady = true
        } else
          this.error = await result.text()
        this.populateIds(this.leftRoot)
      },

      populateIds(def) {
        function f(path, d) {
          if (d.kind) {
            d.id = name(path);
          }
          if (d.attrs && d.attrs.length) {
            for (let attr of d.attrs) {
              if (attr && attr.value) {
                const va = (attr.value.def && [attr.value] || attr.value.array || []).filter(v => v.def).map(v => v.def)
                for (let v of va) {
                  f(path.concat([attr, v]), v)
                }
              }
            }
          }
        }

        f([def], def);
        function name(path) {
          return path.slice(1).filter(p => p && p.kind).map(p => p.name).join(".")
        }
      },

      updateScript() {
        const shell = getShell(this.leftRoot, this.left.id)

        console.log({shell})
        console.log({sel: this.selectedRows})

        const diffs = this.selectedRows.map(i => this.diffs[i.id])

        for (let diff of diffs) {
          let parent = this.getDefById(this.left.id, shell)
          let array = false

          const path = diff.path.split('.').slice(1)
          for (let segment of path) {
            if (segment.startsWith('@')) {
              //parent is def
              let attr = segment.substring(1)
              array = attr.endsWith('[]')
              if (array) {
                attr = attr.substring(0, attr.length - 2)
              }
              if (!parent.attrs.some(a => a.name === attr)) {
                parent.attrs.push({name: attr, value: {}})
              }
              parent = parent.attrs.find(a => a.name === attr)
              if (array && !parent.value.array) {
                parent.value.array = []
              }
            } else {
              //parent is attr
              const name = segment.split(':')[0]
              const kind = segment.split(':')[1]
              if (array) {
                if (!parent.value.array.some(v => v.def?.name === name)) {
                  parent.value.array.push({def: {name: name, kind: kind, attrs: []}})
                }
                parent = parent.value.array.find(v => v.def?.name === name).def
              } else {
                if (parent.value.def?.name !== name) {
                  parent.value.def = {name: name, kind: kind, attrs: []}
                }
                parent = parent.value.def
              }
            }
          }

          switch (diff.type) {
            case 'Array.Left.Def':
              //parent should be attr of type array
              parent.value.array.push({def: diff.left})
              break;
            case 'Attr.Diff.Value':
            case 'Attr.Left':
              //parent should be def
              parent.attrs.push(diff.attr)
              break;
            case 'Def.Exclude.Left':
              //parent should be def
              parent.exclude = diff.left
              break;
            case 'Def.Revert.Left':
              //parent should be def
              parent.revert = diff.left
              break;
            case 'Attr.Value.Exclude.Left':
              //parent should be attr
              parent.value.exclude = diff.left
              if (!parent.value.array)
                parent.value.array = []  
              break;
            case 'Attr.Value.Revert.Left':
              //parent should be attr
              parent.value.revert = diff.left
              if (!parent.value.array)
                parent.value.array = []                
              break;
          }

        }

        function removeVer(d) {
          if (Array.isArray(d))
            d = d.map(removeVer)
          else if (typeof d == 'object') {
            delete d.ver
            d = Object.keys(d).reduce((o, k) => ({...o, [k]: removeVer(o[k])}), d)
          }
          
          return d
        }
        
        this.script = JSON.stringify(removeVer(shell))

        function getShell(root, id) {
          console.log({shell: root.id, id})

          const shell = {name: root.name, kind: root.kind, id: root.id, attrs: []}

          if (root.id === id)
            return shell

          shell.attrs = shell.attrs.concat(
              root.attrs.filter(a => a.value?.def && id.match(`^${a.value.def.id}(\\..+|$)`))
                  .map(a => ({...a, value: {def: getShell(a.value.def, id)}})))

          shell.attrs = shell.attrs.concat(
              root.attrs.filter(a => a.value?.array)
                  .map(a => ({
                    ...a,
                    value: {array: a.value.array.filter(av => av.def && id.match(`^${av.def.id}(\\..+|$)`)).map(av => ({def: getShell(av.def, id)}))}
                  }))
                  .filter(a => a.value.array.length)
          )

          return shell
        }
      },

      async downloadRight() {
        this.rightReady = false;
        this.rightRoot = null
        var result
        if(this.Layer.name===null)
        {
         result = await fetch(this.rightUrl)
        }
        else{
        const body=JSON.stringify({"layer":{"name": "", "kind": "", "attrs": [{"name": this.Layer.name, "value":{"number": this.rightUrlNumber}}]}})
         result = await fetch( this.rightUrl2,
         {method: 'POST', headers: {'Accept': 'application/json','Content-Type': 'application/json'},body:body })
        }
        if (result.ok) {
          this.rightRoot = await result.json()
          this.rightReady = true
        } else
          this.error = await result.text()
        this.populateIds(this.rightRoot)
      },

      async downloadLeftVers() {
        this.downloading = true
        try {
          const vers = this.diffs.map(item => item.left && item.left.ver || item.leftDef && item.leftDef.ver).filter(v => v)
          const minVer = Math.min(...vers)
          const maxVer = Math.max(...vers)
          this.vers = await Promise.all(
              Array.from({length: maxVer - minVer + 1}, (v, k) => k + minVer)
                  .map(async v => await fetch(this.leftBaseUrl + `/${v}`)
                      .then(r => r.json())))
        } finally {
          this.downloading = false
        }
      },

      flatten(def) {
        const list = []
        this.flattenDef(def, def.name, list)
        return list
      },

      flattenDef(def, path, list) {
        function explode(def) {
          return def.exclude || def.revert || def.base?.ref || def.attrs?.some(a => a.value?.def && explode(a.value?.def) || a.value?.array?.some(v => v.def))
        }

        if (!explode(def)) {
          list.push({op: 'def', path, value: def})
          return
        }
        if (def.exclude)
          list.push({op: 'exclude', path, value: def.exclude})
        if (def.revert)
          list.push({op: 'revert', path, value: def.revert})
        if (def.base?.ref)
          list.push({op: 'base', path, value: def.base.ref})
        for (const attr of def.attrs || []) {
          this.flattenAttr(attr, path, list)
        }
      },

      flattenAttr(attr, path, list) {
        if (attr.exclude)
          list.push({op: 'exclude', path: path + '.@' + attr.name, value: attr.exclude})
        if (attr.revert)
          list.push({op: 'revert', path: path + '.@' + attr.name, value: attr.revert})

        if (attr.value?.array?.length) {
          this.flattenArray(attr.value.array, path + '.@' + attr.name + "[]", list);
        }

        if (attr.value?.def) {
          this.flattenDef(attr.value.def, path + '.@' + attr.name, list);
        }

        if (attr.value?.ref || this.valueValue(attr.value) != null) {
          list.push({op: 'value', path: path + '.@' + attr.name, value: attr.value})
        }
      },

      flattenArray(array, path, list) {
        for (const l of array) {
          if (l.def) {
            this.flattenDef(l.def, path + "." + l.def.name, list)
          } else if (l.ref || this.valueValue(l) != null) {
            list.push({op: 'value', path: path, value: l.value})
          }
        }
      },

      async compare() {
        this.diffReady = false
        this.diffs = []
        this.leftItems = []
        this.selectedRows = []

        console.log({l: this.leftRoot, r: this.rightRoot})

        this.left = this.getDefById(this.compareRoot.defId, this.leftRoot)
        this.right = this.getDefById(this.compareRoot2.defId, this.rightRoot)

        console.log({l: this.left, r: this.right})

        /*const left = this.left
        const right = this.right
        
        if (left.kind !== right.kind || left.name !== right.name) {
          this.error = `${left.kind} !== ${right.kind} || ${left.name} !== ${right.name} (${left.id} vs ${right.id})`
          return
        }*/
        
        this.compareDef(this.left, this.right, this.left.name, this.compareRoot.attrName)
        console.log(this.diffs)
        this.leftItems = [this.toItemDef(this.left)]
        this.diffReady = true
      },

      getDefById(id, d) {
        if (d.id === id)
          return d;

        if (d.attrs && d.attrs.length) {
          for (let attr of d.attrs) {
            if (attr && attr.value) {
              const va = (attr.value.def && [attr.value] || attr.value.array || []).filter(v => v.def).map(v => v.def)
              for (let v of va) {
                const r = this.getDefById(id, v)
                if (r)
                  return r;
              }
            }
          }
        }
      },

      toItemDef(def, parent) {
        const id = (parent ? parent.id + "/" : "") + def.name
        const node = {
          parent,
          def,
          id,
          name: def.name,
        }

        node.children = this.defNodeChildren(node) || []

        node.diffs = this.diffs.filter(d => d.array && d.array === parent?.attr?.value?.array && (d.left?.def || d.left) === node.def)

        node.diffs.push(...this.diffs.filter(d => d.array && d.array === parent?.attr?.value?.array && (d.right?.def || d.right) === node.def))

        node.diffs.push(...this.diffs.filter(d => d.def && d.def === parent?.def && d.left?.value?.def === node.def))

        node.diffs.forEach(d => d.found = true)

        if (node.diffs.length) {
          for (const c of node.children)
            c.parentDiff = true
        }

        if (parent)
          parent.childrenDiffs ||= node.diffs.length || node.childrenDiffs

        if (parent && !node.diffs.length && !node.childrenDiffs)
          return null

        return node
      },

      defNodeChildren(node) {
        return node.def.attrs?.map(a => this.toItemAttr(a, node)).filter(node => node)
      },

      toItemAttr(attr, parent) {
        if (attr.value?.def) {
          return this.toItemDef(attr.value.def, parent)
        }

        const id = (parent ? parent.id + "/" : "") + '@' + attr.name
        const node = {
          parent,
          attr,
          id,
          name: attr.name,
        }

        const missing = this.diffs.filter(d => d.array && d.array === attr.value?.array && d.left == null).map(d => d.right)

        node.children = (node.attr.value?.array ?? []).concat(missing).map(v => this.toItemAttrValue(v, node)).filter(node => node)

        node.diffs = this.diffs.filter(d => d.attr === attr || d.left === attr)

        node.diffs.forEach(d => d.found = true)

        if (node.diffs.length) {
          for (const c of node.children)
            c.parentDiff = true
        }

        if (parent)
          parent.childrenDiffs ||= node.diffs.length || node.childrenDiffs

        if (!node.diffs.length && !node.childrenDiffs)
          return null

        return node
      },

      toItemAttrValue(v, parent) {
        if (v.def)
          return this.toItemDef(v.def, parent)

        console.log(v)
      },

      compareDef(left, right, path, attrName) {
         if (left.base?.kind !== right.base?.kind || left.base?.name !== right.base?.name) {
          this.diffs.push({leftDef: left, def: left, type: "Def.Base", left: left.base, right: right.base, path})
        }

        const leftExclude = (left.exclude ?? []).filter(e => !right.exclude?.includes(e))
        const rightExclude = (right.exclude ?? []).filter(e => !left.exclude?.includes(e))
        
        if (leftExclude.length) {
          this.diffs.push({leftDef: left, def: left, type: "Def.Exclude.Left", left: leftExclude, path})
        }

        if (rightExclude.length) {
          this.diffs.push({leftDef: left, def: left, type: "Def.Exclude.Right", right: rightExclude, path})
        }

        const leftRevert = (left.revert ?? []).filter(e => !right.revert?.includes(e))
        const rightRevert = (right.revert ?? []).filter(e => !left.revert?.includes(e))

        if (leftRevert.length) {
          this.diffs.push({leftDef: left, def: left, type: "Def.Revert.Left", left: leftRevert, path})
        }

        if (rightRevert.length) {
          this.diffs.push({leftDef: left, def: left, type: "Def.Revert.Right", right: rightRevert, path})
        }
        
        for (const leftAttr of left.attrs || []) {
          if (attrName && leftAttr.name !== attrName)
            continue

          const rightAttr = (right.attrs || []).find(a => a.name === leftAttr.name)
          if (!rightAttr) {
            this.diffs.push({
              leftDef: left,
              def: left,
              type: "Attr.Left",
              attr: leftAttr,
              left: leftAttr.value,
              right: null,
              path
            })
          } else {
            this.compareAttr(leftAttr, rightAttr, path, left)
          }
        }

        for (const rightAttr of right.attrs || []) {
          if (attrName && rightAttr.name !== attrName)
            continue

          const leftAttr = (left.attrs || []).find(a => a.name === rightAttr.name)
          if (!leftAttr) {
            this.diffs.push({
              leftDef: left,
              def: left,
              type: "Attr.Right",
              attr: rightAttr,
              left: null,
              right: rightAttr.value,
              path
            })
          }
        }
      },

      compareAttr(left, right, path, leftDef) {
        const leftExclude = (left.value?.exclude ?? []).filter(e => !right.value?.exclude?.includes(e))
        const rightExclude = (right.value?.exclude ?? []).filter(e => !left.value?.exclude?.includes(e))

        if (leftExclude.length) {
          this.diffs.push({leftDef: left, def: left, type: "Attr.Value.Exclude.Left", left: leftExclude, path: path + '.@' + left.name})
        }

        if (rightExclude.length) {
          this.diffs.push({leftDef: left, def: left, type: "Attr.Value.Exclude.Right", right: rightExclude, path: path + '.@' + left.name})
        }

        const leftRevert = (left.value?.revert ?? []).filter(e => !right.value?.revert?.includes(e))
        const rightRevert = (right.value?.revert ?? []).filter(e => !left.value?.revert?.includes(e))

        if (leftRevert.length) {
          this.diffs.push({leftDef: left, def: left, type: "Attr.Value.Revert.Left", left: leftRevert, path: path + '.@' + left.name})
        }

        if (rightRevert.length) {
          this.diffs.push({leftDef: left, def: left, type: "Attr.Value.Revert.Right", right: rightRevert, path: path + '.@' + left.name})
        }

        if (left.value?.array?.length) {
          if (!right.value?.array?.length)
            this.diffs.push({leftDef, attr: left, type: "Attr.Left", left: left.value, right: null, path})
          else
            this.compareArray(left.value.array, right.value.array, path + '.@' + left.name + "[]", leftDef);
        }

        if (left.value?.def) {
          if (!right.value?.def)
            this.diffs.push({attr: left, type: "Attr.Left.Def", left: left.value.def, right: null, path})
          else
            this.compareDef(left.value.def, right.value.def, path + '.@' + left.name + '.' + left.value.def.name + ':' + left.value.def.kind);
        }

        if (left.value?.ref) {
          if (!right.value?.ref)
            this.diffs.push({leftDef, attr: left, type: "Attr.Left.Value", left: left.value, right: null, path})
          else if (left.value.ref.kind !== right.value.ref.kind || left.value.ref.name !== right.value.ref.name)
            this.diffs.push({
              leftDef,
              attr: left,
              type: "Attr.Diff.Value",
              left: left.value,
              right: right.value.ref,
              path
            })
        }

        if (this.valueValue(left.value) != null) {
          if (this.valueValue(right.value) == null)
            this.diffs.push({leftDef, attr: left, type: "Attr.Left.Value", left: left.value, right: null, path})
          else if (this.valueValue(left.value) !== this.valueValue(right.value))
            this.diffs.push({leftDef, attr: left, type: "Attr.Diff.Value", left: left.value, right: right.value, path})
        }

        if (right.value?.array?.length && !left.value?.array?.length) {
          this.diffs.push({leftDef, attr: left, type: "Attr.Right.Array", left: null, right: right.value.array, path})
        }

        if (right.value?.def && !left.value?.def) {
          this.diffs.push({leftDef, attr: left, type: "Attr.Right.Def", left: null, right: right.value.def, path})
        }

        if (right.value?.ref && !left.value?.ref) {
          this.diffs.push({leftDef, attr: left, type: "Attr.Right.Value", left: null, right: right.value, path})
        }

        if (this.valueValue(right.value) != null && this.valueValue(left.value) == null) {
          this.diffs.push({leftDef, attr: left, type: "Attr.Right.Value", left: null, right: right.value, path})
        }
      },

      compareArray(left, right, path, leftDef) {
        for (const l of left) {
          if (l.def) {
            const r = right.find(v => v.def?.kind === l.def.kind && v.def?.name === l.def.name)
            if (!r)
              this.diffs.push({array: left, type: "Array.Left.Def", left: l.def, right: null, path})
            else
              this.compareDef(l.def, r.def, path + "." + l.def.name + ':' + l.def.kind)
          } else if (l.ref) {
            const r = right.find(v => v.ref?.kind === l.ref.kind && v.ref?.name === l.ref.name)
            if (!r)
              this.diffs.push({leftDef, array: left, type: "Array.Left.Value", left: l, right: null, path})
          } else if (this.valueValue(l) != null) {
            const r = right.find(v => this.valueValue(v) === this.valueValue(l))
            if (!r)
              this.diffs.push({leftDef, array: left, type: "Array.Left.Value", left: l, right: null, path})
          }
        }
        for (const r of right) {
          if (r.def && !left.find(v => v.def?.kind === r.def.kind && v.def?.name === r.def.name))
            this.diffs.push({leftDef, array: left, type: "Array.Right.Def", left: null, right: r.def, path})
          else if (r.ref && !left.find(v => v.ref?.kind === r.ref.kind && v.ref?.name === r.ref.name))
            this.diffs.push({leftDef, array: left, type: "Array.Right.Value", left: null, right: r, path})
          else if (this.valueValue(r) != null && !left.find(v => this.valueValue(v) !== this.valueValue(r)))
            this.diffs.push({leftDef, array: left, type: "Array.Right.Value", left: null, right: r, path})
        }
      },

      valueValue(v) {
        return v?.text != null ? v.text : v?.number != null ? v.number : v?.bool != null ? v.bool : null
      },
    }
  }
</script>

<style scoped>

</style>
